import { ReactNode } from 'react'

interface ProviderConfig {
  component: React.ComponentType<any>
  props?: Record<string, any>
}

export const composeProviders = (providers: ProviderConfig[]) => {
  return ({ children }: { children: ReactNode }) => {
    return providers.reduceRight((acc, { component: Provider, props = {} }) => {
      return <Provider {...props}>{acc}</Provider>
    }, children)
  }
}
